<template>
  <b-container class="d-flex flex-column flex-grow-1 config-view">
    <vue-headful :title="this.setPageTitle('configurations')" />
    <b-row class="mt-4 mb-3">
      <b-col>
        <div class="settings-title">{{ $t('configurations.title') }}</div>
      </b-col>
    </b-row>
    <b-row class="d-flex flex-grow-1">
      <b-col cols="3" class="settings-sidebar">
        <div v-for="group in visibleGroups" :key="group.key" class="settings-sidebar__group">
          <div class="settings-sidebar__group-label">{{ $t('configurations.groups.' + group.key) }}</div>
          <b-nav vertical>
            <b-nav-item
              v-for="item in group.items"
              :key="item.link"
              exact
              :to="'/configurations/' + item.link"
              exact-active-class="is-active"
              class="settings-sidebar__item"
              >{{ $t('configurations.items.' + item.key) }}</b-nav-item
            >
          </b-nav>
        </div>
      </b-col>
      <b-col cols="9" class="settings-content">
        <router-view></router-view>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// Sidebar is grouped (OKV-240). "Build Information" is now visible to everyone: non-admins just see
// the software version inside that page (see BuildInformation.vue). An item that names a permission in
// `requires` is shown only to who holds it (the issuers and operations back offices need `canValidate`).
const GROUPS = [
  {
    key: 'preferences',
    items: [{ key: 'notifications', link: 'notifications' }],
  },
  {
    key: 'administration',
    items: [
      { key: 'issuers', link: 'issuers', requires: 'canValidate' },
      { key: 'operations', link: 'operations', requires: 'canValidate' },
    ],
  },
  {
    key: 'information',
    items: [{ key: 'buildInformation', link: 'buildInformation' }],
  },
]

export default {
  data() {
    return {
      groups: GROUPS,
    }
  },
  computed: {
    // A group left with no item the user may open is not shown at all.
    visibleGroups() {
      return this.groups
        .map((group) => ({ ...group, items: group.items.filter((item) => !item.requires || this.$can(item.requires)) }))
        .filter((group) => group.items.length > 0)
    },
  },
}
</script>

<style lang="scss" scoped>
.config-view {
  /* 105px = navbar(45px) + footer(60px) */
  min-height: calc(100vh - 105px);
}

.settings-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #1f2430;
}
.settings-sidebar {
  padding: 0.25rem 1rem 1rem 0.5rem;
}
.settings-sidebar__group + .settings-sidebar__group {
  margin-top: 1.25rem;
}
.settings-sidebar__group-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #99a1ad;
  margin-bottom: 0.25rem;
  padding-left: 0.75rem;
}

/deep/ .settings-sidebar__item .nav-link {
  color: #3b4452;
  font-size: 1rem;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  transition: background 0.12s, color 0.12s;
}
/deep/ .settings-sidebar__item .nav-link:hover {
  background: #f1f3f6;
  color: #1f2430;
}
/deep/ .settings-sidebar__item .nav-link.is-active {
  background: rgba(234, 99, 62, 0.1);
  color: var(--primary, #ea633e);
  font-weight: 600;
}

.settings-content {
  padding: 0.25rem 1rem 1.5rem 1rem;
}
</style>
